export function getColor(bg: string) {
    if (!bg) return ''
    if (bg.startsWith('#')) bg = bg.slice(1)
    const red = parseInt(bg.slice(0, 2), 16)
    const green = parseInt(bg.slice(2, 4), 16)
    const blue = parseInt(bg.slice(4, 6), 16)
    const color = red * 0.299 + green * 0.587 + blue * 0.114 > 186 ? 'black' : 'white'
    return color
}
